/* global axios */
import ApiClient from './ApiClient';

class AutomationConfigAPI extends ApiClient {
  constructor() {
    super('automation_config', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  save(sendingEnabled) {
    return axios.patch(this.url, { sending_enabled: sendingEnabled });
  }
}

export default new AutomationConfigAPI();
